module.exports = __webpack_public_path__ + "static/media/γράφω_second_aorist_passive_img.a6da6c9e.JPG";